module.exports = __webpack_public_path__ + "media/img/prices/career-mag-368a22ee65f354917a006369767241b8.png";